import _ from 'lodash';
import { getCountry } from '../../iwIntlProvider/CountryProvider';

export const required = (value) =>
    value ? undefined : 'This field is required';

export const rejectAmericanExpress = (value) =>
    value && _.startsWith(value, '3')
        ? 'American Express is not supported'
        : undefined;

export const validateCardNumber = (value) => {
    if (/[^0-9-\s]+/.test(value)) return false;

    let isValid;
    let nCheck = 0;
    let bEven = false;

    value = value.replace(/\D/g, '');

    for (let n = value.length - 1; n >= 0; n--) {
        let cDigit = value.charAt(n);
        let nDigit = parseInt(cDigit, 10);

        if (bEven) {
            if ((nDigit *= 2) > 9) nDigit -= 9;
        }

        nCheck += nDigit;
        bEven = !bEven;
    }

    isValid = nCheck % 10 === 0;

    if (!isValid) {
        return 'Invalid card number';
    }
};

export const validatePostcode = (validationErrorMessage, value) => {
    switch (getCountry()) {
        case 'UK':
            if (!value) return validationErrorMessage;
            break;
        case 'DE':
            if (!value || value.length !== 5) return validationErrorMessage;
            break;
    }

    return undefined;
};
